import React, { useEffect, useState } from 'react';
import { Sparkles, PenLine } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { DigitBoxInput } from '../ui/DigitBoxInput';
import { lotteryService } from '../../services/lotteryService';
import { TICKET_NUMBER_LENGTH } from '../../utils/ticketNumberUtils';

export function FeaturedNumberPicker({
  selectedNumber,
  onSelectNumber,
  manualInput,
  onManualInputChange,
}) {
  const [featuredNumbers, setFeaturedNumbers] = useState([]);

  useEffect(() => {
    lotteryService.getFeaturedNumbers().then(setFeaturedNumbers);
  }, []);

  const handleDigitsChange = (value) => {
    onManualInputChange(value);
    if (value.length === TICKET_NUMBER_LENGTH) {
      onSelectNumber(value);
    }
  };

  return (
    <Card className="border-2 border-brand-gold/30 bg-gradient-to-br from-white to-brand-gold-light/20">
      <CardHeader className="border-brand-gold/20 bg-brand-red/5">
        <CardTitle className="flex items-center gap-2 text-brand-red">
          <Sparkles className="h-5 w-5 text-brand-gold" />
          Featured — เลือกเลขโชคดี
        </CardTitle>
        <p className="mt-1 text-sm text-gray-600">
          เลือกเลขเด่นหรือกรอกเลข {TICKET_NUMBER_LENGTH} หลักที่ต้องการ
        </p>
      </CardHeader>
      <CardContent className="space-y-5">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {featuredNumbers.map((item) => {
            const isSelected = selectedNumber === item.number;
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => {
                  onSelectNumber(item.number);
                  onManualInputChange(item.number);
                }}
                className={`rounded-xl border-2 p-3 text-center transition-all ${
                  isSelected
                    ? 'border-brand-red bg-brand-gold-light shadow-md'
                    : 'border-gray-200 bg-white hover:border-brand-gold hover:shadow-sm'
                }`}
              >
                <p className="font-mono text-lg font-bold text-brand-red">
                  {item.number}
                </p>
                <p className="mt-1 text-xs text-gray-500">{item.label}</p>
              </button>
            );
          })}
        </div>

        <div>
          <label className="mb-3 flex items-center justify-center gap-1 text-sm font-medium text-gray-700">
            <PenLine className="h-4 w-4" />
            กรอกเลขเอง ({TICKET_NUMBER_LENGTH} หลัก)
          </label>
          <DigitBoxInput
            id="featured-number"
            length={TICKET_NUMBER_LENGTH}
            value={manualInput}
            onChange={handleDigitsChange}
          />
        </div>

        {selectedNumber && selectedNumber.length === TICKET_NUMBER_LENGTH && (
          <div className="rounded-lg border border-brand-gold bg-brand-gold-light/30 px-4 py-3 text-center">
            <span className="text-sm text-gray-600">เลขที่เลือก: </span>
            <span className="font-mono text-2xl font-bold text-brand-red">
              {selectedNumber}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
